import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1030"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.649 3.743 8.35.095a.693.693 0 0 0-.701 0L1.351 3.743A.705.705 0 0 0 1 4.352v7.296c0 .251.134.483.351.609l6.298 3.648a.688.688 0 0 0 .701 0l6.298-3.648a.703.703 0 0 0 .352-.609V4.352a.705.705 0 0 0-.351-.609zm-1.052 7.499L8 14.484l-5.597-3.242V4.759L8 1.516l5.597 3.242v6.484z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M7.772 5.29a.704.704 0 0 0-.956.256L6.208 6.6 5.6 5.546a.704.704 0 0 0-.956-.256.703.703 0 0 0-.257.956L4.995 7.3H3.778a.7.7 0 1 0 0 1.4h1.217l-.608 1.054a.704.704 0 0 0 .257.957.704.704 0 0 0 .956-.256L6.208 9.4l.608 1.054a.704.704 0 0 0 .956.256.704.704 0 0 0 .257-.957L7.421 8.7h1.216a.7.7 0 1 0 0-1.4H7.421l.608-1.054a.703.703 0 0 0-.257-.956zm2.615 2.221a.7.7 0 0 0 .849-.509l.221-.881a.7.7 0 1 0-1.358-.34l-.221.881a.7.7 0 0 0 .509.849zm1.46 1.796a.7.7 0 0 0 .848-.51l.22-.881a.7.7 0 1 0-1.358-.339l-.22.881a.7.7 0 0 0 .51.849zM9.912 11.22a.7.7 0 0 0 .849-.509l.221-.881a.7.7 0 1 0-1.358-.34l-.221.881a.7.7 0 0 0 .509.849z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }